'use client'

import type { ReactNode } from 'react'

import Accordion from 'react-bootstrap/Accordion'
import parse from 'html-react-parser'

interface AccordionGeneralItem {
  title?: ReactNode
  content?: ReactNode
  subcontent?: ReactNode
  date?: string
  image?: string
  imageAlt?: string
}
interface AccordionGeneralProps {
  list?: AccordionGeneralItem[]
  source?: string
}

function AccordionGeneral({ list = [], source }: AccordionGeneralProps) {
  return (
    <Accordion id="virtual-banking" defaultActiveKey={null}>
      {list?.map((item, index) => (
        <Accordion.Item
          eventKey={index.toString()}
          data-aos="fade-down"
          // data-aos-delay={`${index}00`}
          key={index}
        >
          <Accordion.Header className="no-margin-smallscreen">
            <div className="d-inline-flex align-items-center">
              <div className="p-2">
                <h3 style={{ color: '#000045', margin: '0' }}>{item.title}</h3>
              </div>
            </div>
          </Accordion.Header>
          <Accordion.Body>
            <div data-aos="fade-up">
              <div className="position-relative d-flex flex-1 flex-column gap-6 py-1 md:gap-10">
                <div className="position-relative z-0 d-flex gap-6 pl-1.5 md:gap-8">
                  <div>
                    {source === 'cms' ? (
                      <p>Posted on: {item?.date}</p>
                    ) : (
                      item.date && <p>{item?.date}</p>
                    )}
                    {source === 'cms' ? (
                      item?.content &&
                      (typeof item.content === 'string' ? parse(item.content) : item.content)
                    ) : (
                      <div>{item?.content}</div>
                    )}
                    {item?.image && (
                      <div className="d-flex align-items-center justify-content-left">
                        <img
                          src={item?.image}
                          alt={item?.imageAlt || 'Image'}
                          style={{
                            maxWidth: '100%',
                            marginTop: '10px',
                            marginBottom: '40px'
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <p>{item.subcontent}</p>
            </div>
          </Accordion.Body>
        </Accordion.Item>
      ))}
    </Accordion>
  )
}

export default AccordionGeneral
